import { AccessPriviledgeContent } from "../Add/AccessPrivilage/AccessPriviledgeContent";
import { transformString } from "../commonfunctions/transformString";
import useTranslation from "../CustomHooks/useTranslation";
import PTagFramer from "../framerMotion/PTagFramer";

interface CheckBoxWithLabelProps {
  label?: string;
  handelCheckBox?: (id: string, checked: boolean) => void; // Optional callback function
  checked: boolean;
  disabled?: boolean;
  id?: string;
  fontWeight?: string;
  textClassName?: string;
  error?: boolean;
  isBusinessAssignedArea?: boolean;
}


export default function CheckBoxWithLabel({
  label,
  handelCheckBox,
  checked,
  disabled,
  id,
  textClassName,
  fontWeight,
  error,
  isBusinessAssignedArea = false,
}: CheckBoxWithLabelProps) {
  const { translate, notEnglish } = useTranslation(AccessPriviledgeContent);
  return (
    <PTagFramer>
      {label && (
        <div
          className={`relative my-2 flex items-center ${
            error && !disabled ? "label-checkbox-error" : ""
          } ${disabled ? "label-checkbox-disabled" : "label-checkbox"} ${
            notEnglish ? "reverse-label-checkbox gap-3" : ""
          }`}
          dir={notEnglish ? "rtl" : "ltr"}
          onClick={() => {
            if (!disabled && isBusinessAssignedArea) {
              handelCheckBox?.(label || "", !checked);
            }
          }}
          style={{ cursor: disabled ? "not-allowed" : "pointer" }}
        >
          <input
            className="checkbox cursor-pointer"
            type="checkbox"
            checked={checked}
            disabled={disabled}
            data-testid={"check-box"}
            id={id || label}
            onChange={(e) => handelCheckBox?.(label || "", e.target.checked)}
            onClick={(e) => e.stopPropagation()} // Prevent double toggle when clicking checkbox
          />
          <label
            data-testid={id || label}
            htmlFor={id || label}
            className={`inline-block ml-1 ${
              textClassName || "text-[14px] leading-[22px]"
            } ${fontWeight || "font-[400]"} ${
              disabled
                ? "text-disable_stroke"
                : textClassName
                ? textClassName
                : "text-primary_text cursor-pointer"
            }`}
          >
            {translate(label)}
          </label>
        </div>
      )}
    </PTagFramer>
  );
}
